import '@mdi/font/css/materialdesignicons.min.css'
import 'buefy/dist/buefy.css'
import './main.styl'
import 'util/polyfill'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import { i18n } from './i18n'
import Axios from 'axios'
import Buefy from 'buefy'
import MapEngine from 'util/MapEngine'

import('conf/' + window.app.id).then(config => {
  if (!config.enabled) {
    return false
  }
  i18n.locale = config.default.locales[0]
  store.dispatch('config', config.default)
  Vue.use(Buefy)
  Vue.prototype.$app = window.app
  Vue.prototype.$conf = config.default
  Vue.prototype.$map = new MapEngine(config.default.map)
  Vue.prototype.$http = Axios
  const token = window.localStorage.getItem(window.app.id + '.login.token')
  const expire = window.localStorage.getItem(window.app.id + '.login.expire')
  if (token) {
    // auth expired
    if (expire && Math.floor(Date.now() / 1000) < Number(expire)) {
      Vue.prototype.$http.defaults.headers.common['Authorization'] = token
    } else {
      store.dispatch('logout')
    }
  }
  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
  })
})
